import basedataApi from '@/api/basedata';
import _ from 'lodash';
import utils from '@/util/utils';

const baseDataTypes = {
    'Organization': {
        idField: 'id',
        nameField: 'organizName',
        rowIdField: 'organizId',
    },
    'MedicalField': {
        idField: 'id',
        nameField: 'medicalFieldName',
        rowIdField: 'medicalField',
    },
    'Teams': {
        idField: 'id',
        nameField: 'teamName',
        rowIdField: 'teamId',
    },
    'Product': {
        idField: 'id',
        nameField: 'productName',
        rowIdField: 'productId',
    },
    'Depart': {
        idField: 'id',
        nameField: 'departName',
        rowIdField: 'departId',
    },
    'TreatmentArea': {
        idField: 'id',
        nameField: 'treatmentAreaName',
        rowIdField: 'treatmentAreaId',
    },
    'DiseaseArea': {
        idField: 'id',
        nameField: 'diseaseAreaName',
        rowIdField: 'diseaseAreaId',
    },
    'Country': {
        idField: 'id',
        nameField: 'name',
    },
    'Province': {
        idField: 'id',
        nameField: 'name',
    },
    'HospitalLevel': {
        idField: 'id',
        nameField: 'hospitalLevel'
    },
    'SpeakerLevel': {
        idField: 'id',
        nameField: 'speakerLevel'
    },
    'DomainResult': {
        idField: 'id',
        nameField: 'treatAreaResult'
    },
    'Strategy': {
        idField: 'id',
        nameField: 'keynote'
    },
    'Office': {
        idField: 'id',
        nameField: 'officeName'
    },
    'Year': {
        idField: 'id',
        nameField: 'yearName'
    },
    'Quarter': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'quarter',
    },
    'CostCenter': {
        idField: 'id',
        nameField: 'costName',
        rowIdField: 'costCenter',
    },
    'WbsCode': {
        idField: 'id',
        nameField: 'costName',
        rowIdField: 'wbsCode',
    },
    'MyApplicationStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'status',
    },
    'MyLibraryStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'status',
    },
    'MyTaskStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'status',
    },
    'MeetingStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingWebStatus',
    },
    'QueueTaskStatus': {
        idField: 'value',
        nameField: 'text',
    },
    'CompanyStrategy': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'companyStrategy',
    },
    'MeetingProp': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingProp',
    },
    'MeetingModality': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingModality',
    },
    'MeetingType': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingType',
    },
    'Role': {
        idField: 'id',
        nameField: 'roleName',
        rowIdField: 'roleId',
    },
    'MeetingSystem': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingSystem',
    },
    'AoneExeStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'aoneExeStatus',
    },
    'MeetingTimeInt': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingTimeInt',
    },
    'SysErrorTip': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'sysErrorTip',
    },
    'SysTip': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'sysTip',
    },
    'MeetingGsdType': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdType',
    },
    'MeetingGsdTypeSub1': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdTypeSub1',
    },
    'MeetingGsdTypeSub2': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdTypeSub2',
    },
    'MeetingGsdTypeSub3': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdTypeSub3',
    },
}

const state = {
    baseDataRecords: {},
    baseDataRecordsById: {
  }
};

const getters = {
    baseDataRecordByType: (state) => (type) => {
        return state.baseDataRecords[type];
    },
    baseDataRecords(state) {
        return state.baseDataRecords;
    },
    basedataGetIdByName: (state) => (type, name) => {
        for (let index = 0; index < state.baseDataRecords[type].length; index++) {
            const element = state.baseDataRecords[type][index];

            if(element[baseDataTypes[type].nameField] == name) {
                return element[baseDataTypes[type].idField]
            }            
        }

        return '';
    },
    basedataGetName: (state) => (type, id, extend) => {
        if(!id) {
            return ''
        }

        if(Array.isArray(id)){
            let names = [];
            id.forEach(el => {
                if(extend && extend[el]){
                   
                    names.push(extend[el]);
                }
                else if(state.baseDataRecordsById[type][el]) {
                    names.push(state.baseDataRecordsById[type][el][baseDataTypes[type].nameField])
                }
            })

            return names.join('，');
        }

        if(extend && extend[id]){
            return extend[id];
        }

        if(!state.baseDataRecordsById[type][id]){
            return `id: ${id} 不存在`
        }
        return state.baseDataRecordsById[type][id][baseDataTypes[type].nameField];
    },
    basedataGetObject: (state) => (type, id) => {
        if(!state.baseDataRecordsById[type][id]){
            return `id: ${id} 不存在`
        }
        return state.baseDataRecordsById[type][id];
    },
    basedataGetNameByRowIdField: (state, getters) => (rowIdField, row) => {
        let type = ''
        for (const typeTemp in baseDataTypes) {
            if (baseDataTypes.hasOwnProperty.call(baseDataTypes, typeTemp)) {
                const element = baseDataTypes[typeTemp];
                if(element.rowIdField == rowIdField){
                    type = typeTemp;
                    break;
                }
            }
        }
        let id = row[baseDataTypes[type].rowIdField];

        return getters.basedataGetName(type, id);
    },
};

const mutations = {
    baseDataSet(state, payload) {        
        let typeInfo = baseDataTypes[payload.typeName];
        
        state.baseDataRecords[payload.typeName] = payload.data;
        state.baseDataRecordsById[payload.typeName] = {}                        

        state.baseDataRecords[payload.typeName].forEach(record => {
            state.baseDataRecordsById[payload.typeName][record[typeInfo.idField]] = record; 
        })
    }
};

const actions = {
    async ['reloadBaseDataByType']({
        commit,
        rootGetters,
    }, typeName) {
        let typeInfo = baseDataTypes[typeName];
        const res = await basedataApi['list'+typeName]();

        let data = res.records;
        if(!data){
            //res 是数组
            data = [];
            res.forEach(resdata => {
                let temp = {}
                if(typeof resdata == 'object' ) {
                    temp = resdata;
                }
                else {
                    temp[typeInfo.idField] = resdata;
                    temp[typeInfo.nameField] = resdata;
                }
                data.push(temp)
            })
        }

        if(typeInfo.userInfoField) {
            let tempData = []
            data.forEach(resdata => {
                let info = rootGetters.userInfo[typeInfo.userInfoField];
                if(info && info.indexOf(resdata[typeInfo.idField]) >= 0) {
                    tempData.push(resdata);
                }
            })

            data = tempData;
        }

        commit('baseDataSet', {data, typeName});
    },

    async ['initBaseData'] (
        {
            dispatch,
        }
    ){
        for (const typeName in baseDataTypes) {
            dispatch('reloadBaseDataByType', typeName);
        }
    },

    async ['initBaseDataByTypes'] (
        {
            dispatch,
            state
        },
        typeNameArray
    ){
        let reloadFuncArr = [];
        for (const typeName of typeNameArray) {
            if(!state.baseDataRecords[typeName]) {
                reloadFuncArr.push(dispatch('reloadBaseDataByType', typeName));      
             }
        }

        if(reloadFuncArr.length > 0) {
            await utils.$all(reloadFuncArr);
        }
    },
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/basedata.js